import { BreezeIntelligenceKitProvider } from 'breeze-intelligence-kit';
import { CreditsProvider, CurrentUserProvider } from 'policy-lib';
import { jsx as _jsx } from "react/jsx-runtime";
export const ModalBulkProvider = ({
  children
}) => /*#__PURE__*/_jsx(CurrentUserProvider, {
  children: /*#__PURE__*/_jsx(BreezeIntelligenceKitProvider, {
    children: /*#__PURE__*/_jsx(CreditsProvider, {
      children: children
    })
  })
});